var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-sheet",
    { attrs: { elevation: "2" } },
    [
      _vm.showHeader
        ? _vm._t("header", function () {
            return [
              _c(
                "v-toolbar",
                { attrs: { flat: "", color: "white" } },
                [
                  _vm.title
                    ? _c("v-toolbar-title", { staticClass: "subheading" }, [
                        _vm._v(_vm._s(_vm.title)),
                      ])
                    : _vm._e(),
                  _c("v-spacer"),
                  _vm.chart
                    ? _c("Dialog", {
                        attrs: {
                          icon: "insert_chart",
                          tooltip: "Show Chart",
                          title: _vm.title,
                          body: _vm.chart,
                        },
                      })
                    : _vm._e(),
                ],
                1
              ),
            ]
          })
        : _vm._e(),
      _c(
        "v-data-table",
        _vm._b(
          {
            attrs: {
              headers: _vm.yearlyHeaders,
              items: _vm.tableItems,
              "item-key": "index",
              "hide-default-footer": "",
              "disable-pagination": "",
            },
            scopedSlots: _vm._u([
              {
                key: "item",
                fn: function (props) {
                  return [
                    _c(
                      "tr",
                      [
                        _c(
                          "td",
                          {},
                          [
                            _c(
                              "v-btn",
                              {
                                attrs: { icon: "" },
                                on: {
                                  click: function ($event) {
                                    return props.expand(!props.isExpanded)
                                  },
                                },
                              },
                              [
                                _c("v-icon", {
                                  domProps: {
                                    textContent: _vm._s(
                                      props.isExpanded
                                        ? "expand_less"
                                        : "expand_more"
                                    ),
                                  },
                                }),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                        _vm._l(_vm.headers, function (h) {
                          return _c("td", { key: h.text + "_" + props.index }, [
                            h.parseEnum
                              ? _c(
                                  "span",
                                  {
                                    staticStyle: { "vertical-align": "super" },
                                  },
                                  [
                                    _vm._v(
                                      " " +
                                        _vm._s(
                                          _vm._f("toProperCase")(
                                            _vm._f("replaceUnderscore")(
                                              props.item[h.value]
                                            )
                                          )
                                        ) +
                                        " "
                                    ),
                                  ]
                                )
                              : _c(
                                  "span",
                                  {
                                    staticStyle: { "vertical-align": "super" },
                                  },
                                  [
                                    _vm._v(
                                      " " + _vm._s(props.item[h.value]) + " "
                                    ),
                                  ]
                                ),
                          ])
                        }),
                        _vm._l(_vm.yearCount, function (i) {
                          return _c("td", { key: i + "_" + props.index }, [
                            _vm._v(
                              " " +
                                _vm._s(
                                  _vm._f("formatNumber")(
                                    _vm.transformValue(
                                      props.item[_vm.valueKey][i - 1],
                                      props.item.precision
                                    )
                                  )
                                ) +
                                " "
                            ),
                          ])
                        }),
                      ],
                      2
                    ),
                  ]
                },
              },
              {
                key: "expanded-item",
                fn: function (ref) {
                  var headers = ref.headers
                  var item = ref.item
                  return [
                    _c(
                      "td",
                      {
                        staticClass: "pa-1",
                        attrs: { colspan: headers.length },
                      },
                      [
                        _c("Chart", {
                          attrs: {
                            type: "line",
                            data: _vm.chartData(item),
                            options: _vm.chartOptions,
                          },
                        }),
                      ],
                      1
                    ),
                  ]
                },
              },
            ]),
          },
          "v-data-table",
          _vm.$attrs,
          false
        )
      ),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }